<template>
  <el-dialog class="dialog-info" :title="pageType == 'add' ? '新增跋文': pageType == 'edit' ? '编辑跋文':'查看跋文'" @close="onCancel" :visible.sync="dialogVisible" :width="'600px'">

    <!-- 跋文 -->
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" v-if="roleType==='bawen'">
      <el-form-item label="标题 :" prop="name">
        <el-input v-model="form.name" :disabled="pageType == 'detail'" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="排序 :" prop="sequence">
        <el-input type="number" v-model="form.sequence" :disabled="pageType == 'detail'" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="文字 :" prop="content">
        <el-input type="textarea" v-model="form.content" :disabled="pageType==='detail'"
          :placeholder="pageType  == 'detail'? '' : '请输入'"></el-input>
      </el-form-item>

      <el-form-item label="图片 :" prop="phone">
        <div class="sch-box">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
              :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
              v-if="pageType!=='detail'">
              <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传图片</div>
              </div>
            </el-upload>

            <div class="pic-box" v-if="pageType==='detail'">
              <img :src="imgUrl" alt="">
            </div>
          </div>
      </el-form-item>
    </el-form>

    <!-- 历代著录 -->
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" v-if="roleType==='article'">
      <el-form-item label="标题 :" prop="name">
        <el-input v-model="form.name" :disabled="pageType == 'detail'" placeholder="请输入" />
      </el-form-item>
      
      <el-form-item label="作者 :" prop="author">
        <el-input v-model="form.author" :disabled="pageType == 'detail'" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="文字 :" prop="content">
        <el-input type="textarea" v-model="form.content" :disabled="pageType==='detail'"
          :placeholder="pageType  == 'detail'? '' : '请输入'"></el-input>
      </el-form-item>

      <el-form-item label="排序 :" prop="sequence">
        <el-input type="number" v-model="form.sequence" :disabled="pageType == 'detail'" placeholder="请输入" />
      </el-form-item>

      <!-- <el-form-item label="图片 :" prop="phone">
        <div class="sch-box">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
              :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
              v-if="pageType!=='detail'">
              <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传图片</div>
              </div>
            </el-upload>

            <div class="pic-box" v-if="pageType==='detail'">
              <img :src="imgUrl" alt="">
            </div>
          </div>
      </el-form-item> -->
    </el-form>

    <!-- 图集 -->
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" v-if="roleType==='photo'">
      <el-form-item label="标题 :" prop="name">
        <el-input v-model="form.name" :disabled="pageType == 'detail'" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="排序 :" prop="sequence">
        <el-input type="number" v-model="form.sequence" :disabled="pageType == 'detail'" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="图片 :" prop="phone">
        <div class="sch-box">
          <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
            :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
            v-if="pageType!=='detail'">
            <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
            <div v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__text">上传图片</div>
            </div>
          </el-upload>

          <div class="pic-box" v-if="pageType==='detail'">
            <img :src="imgUrl" alt="">
          </div>
        </div>
      </el-form-item>
    </el-form>


    <div class="dialog-footer tr mt-30" v-if="pageType != 'detail'">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    return {
      pageType: 'add',
      roleType: 'bawen', // bawen 跋文  article 历代著录  photo 图集
      dialogVisible: false,
      collectId: '',
      form: {

      },
      configData: {
        tableName: 'collect'
      },
      imgUrl: '',
      rules: {
        name: [{ required: true, message: '不能为空', trigger: 'blur' }],
      }
    }
  },
  methods: {
    init(item, type, collectId, roleType) {
      this.pageType = type
      this.collectId = collectId
      this.roleType = roleType
      this.dialogVisible = true
      console.log(234, this.roleType)

      if(type !== 'add') {
        this.form.id = item.id
        this.getDetail()
      }
    },
    getDetail() {
      if(this.roleType === 'article') {
        this.getDetail2()
        return
      } else if(this.roleType === 'photo') {
        this.getDetail3()
        return
      }
      this.$http.get('/qinggong/qgCollectPostscript/detail', {
        id: this.form.id
      }).then(res => {
        if (res.success) {
          this.form = res.result
          this.imgUrl = res.result.imgUrl
        }
      })
    },
    getDetail2() {
      this.$http.get('/qinggong/qgCollectBook/detail', {
        id: this.form.id
      }).then(res => {
        if (res.success) {
          this.form = res.result
          this.imgUrl = res.result.imgUrl
        }
      })
    },
    getDetail3() {
      this.$http.get('/qinggong/qgCollectAlbum/detail', {
        id: this.form.id
      }).then(res => {
        if (res.success) {
          this.form = res.result
          this.imgUrl = res.result.imgUrl
        }
      })
    },
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.form.imgId = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.fileIds = fileStr
    },
    onCancel() {
      this.dialogVisible = false
      this.form = {}
      this.imgUrl = ''
      this.$refs["form"].clearValidate()
    },

    onSubmit() {
      if(this.roleType === 'article') {
        this.save2()
        return
      } else if(this.roleType === 'photo') {
        this.save3()
      }

      // 跋文
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "/qinggong/qgCollectPostscript/save"
          if (this.form.id) {
            url = "/qinggong/qgCollectPostscript/update"
          }
          this.$http.post(url, {
            ...this.form,
            collectId: this.collectId
          }).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.form.id ? '修改成功' : '新增成功',
              })

              this.onCancel()
              this.$emit('refresh')
            }
          })
        } else {
          return false;
        }
      });
    },

    save2() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "/qinggong/qgCollectBook/save"
          if (this.form.id) {
            url = "/qinggong/qgCollectBook/update"
          }
          this.$http.post(url, {
            ...this.form,
            collectId: this.collectId
          }).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.form.id ? '修改成功' : '新增成功',
              })

              this.onCancel()
              this.$emit('refresh')
            }
          })
        } else {
          return false;
        }
      });
    },
    save3() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "/qinggong/qgCollectAlbum/save"
          if (this.form.id) {
            url = "/qinggong/qgCollectAlbum/update"
          }
          this.$http.post(url, {
            ...this.form,
            collectId: this.collectId
          }).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.form.id ? '修改成功' : '新增成功',
              })

              this.onCancel()
              this.$emit('refresh')
            }
          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-info {
  .sch-box {
    margin-bottom: 20px;

    .pic-box {
      text-align: center;
      margin-bottom: 30px;
      img {
        max-width: 60%;
      }
    }
  }
  .avatar-uploader {
    width: 50%;
    border: 1px dashed #8c939d;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-upload {
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .el-icon-plus {
      font-size: 20px;
    }

    .el-upload__text {
      line-height: 1;
    }
  }
}
</style>
